
const StorageService = {
    // Function to set a cookie that never expires
    setCookie: (name, value, neverExpires = true) => {
        if (neverExpires) {
            // Set expiration to a far future date (year 2099)
            const expires = new Date('2099-12-31T23:59:59.999Z');
            document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
        } else {
            // Session cookie (expires when browser closes)
            document.cookie = `${name}=${value};path=/`;
        }
    },
    // Function to get a cookie value
    getCookie: (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    // Function to delete a cookie
    deleteCookie: (name) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    },
    // Function to set a cookie that never expires
    setLocal: (name, value) => {
        localStorage.setItem(name, value);
    },
    // Function to get a cookie value
    getLocal: (name) => {
        return localStorage.getItem(name);
    },
    // Function to delete a cookie
    deleteLocal: (name) => {
        localStorage.removeItem(name);
    }
}

export default StorageService;